'use client';

import { useState } from 'react';
import Link from 'next/link';

interface Tag {
  name: string;
  href: string;
}

interface Props {
  tags: Tag[];
  limit?: number;
}

export default function ExpandableTagList({ tags, limit = 20 }: Props) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? tags : tags.slice(0, limit);
  const canExpand = tags.length > limit;

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-2">
        {visible.map((tag, i) => (
          <Link
            key={i}
            href={tag.href}
            className="text-xs font-semibold px-3 py-1.5 rounded-full bg-[var(--bg-secondary)] text-[var(--color-text-secondary)] hover:bg-[var(--color-primary)] hover:text-white transition-colors border border-[var(--color-border)]"
          >
            #{tag.name}
          </Link>
        ))}
      </div>
      {canExpand && (
        <div className="mt-3">
          <button
            type="button"
            onClick={() => setExpanded(v => !v)}
            className="text-xs font-semibold px-3 py-1.5 rounded-full bg-[var(--bg-base)] text-[var(--color-text-muted)] hover:underline border border-dashed border-[var(--color-border)]"
          >
            {expanded ? 'View Less' : '+ View All'}
          </button>
        </div>
      )}
    </div>
  );
}
